import { render, staticRenderFns } from "./PartnerWallet.vue?vue&type=template&id=138d8755&scoped=true&"
import script from "./PartnerWallet.vue?vue&type=script&lang=js&"
export * from "./PartnerWallet.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWallet.vue?vue&type=style&index=0&id=138d8755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d8755",
  null
  
)

export default component.exports